import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from "react";
import * as Cookies from "js-cookie";
/**
 * useCookie - React Hook for Cookies based on js-cookie
 * @param {string} key Cookie name
 * @param {Object|string} [initialValue]  Value will be assign if cookie doesn't exist.
 * @returns {Array} Returns cookie value, and the function to update it.
 */

export function useCookie(key, initialValue) {
  var _useState = useState(function () {
    return Cookies.get(key) || initialValue;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      item = _useState2[0],
      setInnerValue = _useState2[1];
  /**
   * Set value of cookie
   * @param {Object|string} value 
   * @param {Cookies.CookieAttributes} [options]
   */


  var setValue = function setValue(value, options) {
    setInnerValue(value);
    Cookies.set(key, value, options);
  };

  return [item, setValue];
}
export default useCookie;